import VoucherCard from '../../common/VoucherCard';
import styles from './style.module.scss';
import Voucher1 from '../../../assets/voucher1.png';

const VoucherList = () => {
  return (
    <div className={styles.listWrapper}>
      {Array.from({ length: 8 }).map((_, index) => {
        return (
          <VoucherCard
            key={index}
            image={Voucher1}
            title="Lunchbox @99"
            value={100}
          />
        );
      })}
    </div>
  );
};

export default VoucherList;
